import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-7 gap-3" }
const _hoisted_2 = { class: "col-span-4" }
const _hoisted_3 = { class: "col-span-3 grid grid-cols-5 gap-3 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("textarea", {
        class: "p-3 border-next-gray-md-dark border-2 w-full",
        rows: "9",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textModel) = $event))
      }, null, 512), [
        [_vModelText, _ctx.textModel]
      ])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_VueMultiselect, {
          searchable: true,
          multiple: true,
          taggable: true,
          "close-on-select": true,
          "clear-on-select": true,
          class: "next-vue-multiselect",
          placeholder: "Tags",
          deselectLabel: "Deseleziona",
          selectedLabel: "Selezionato",
          selectLabel: "Seleziona",
          options: _ctx.tagsAutocomplete.options,
          onSearchChange: _ctx.tagsAutocomplete.search,
          onTag: _ctx.tagsAutocomplete.add,
          modelValue: _ctx.tagsAutocomplete.selection,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tagsAutocomplete.selection) = $event)),
          tagPlaceholder: "Aggiungi tag"
        }, {
          tag: _withCtx(({option, remove}) => [
            _createVNode(_component_MultiselectOption, {
              onRemove: ($event: any) => (remove(option))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option), 1)
              ]),
              _: 2
            }, 1032, ["onRemove"])
          ]),
          _: 1
        }, 8, ["options", "onSearchChange", "onTag", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NextButton, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('chiudi'))),
          variant: "outline-secondary",
          class: "col-span-2 text-center py-2 px-4"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Chiudi ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          variant: "primary",
          class: "col-span-3 text-center py-2 px-4",
          disabled: _ctx.$attrs.waiting,
          onClick: _ctx.save
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Salva")
          ])),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}